import { CommandRequestType } from "../../authentication/connection/commandRequestType";
import { ICommandParameters } from "../../authentication/connection/iCommandParameters";
import { ICommandResponse } from "../../authentication/connection/iCommandResponse";
import { ErrorDetails, TimezoneResponse } from "../../authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "../../authentication/connection/iRequestCommand";

export class ListTimezonesCommand extends IRequestCommand<IListTimezonesCommandResponse,
    ErrorDetails,
    IListTimezonesCommandParameters> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _needAuthenticate = false;

  override setParameters() {
    this.urlSections.push('multiregion');
    this.urlSections.push('timezones');
    this.composeUrl();
  }
}

export interface IListTimezonesCommandParameters
    extends ICommandParameters {
}

export interface IListTimezonesCommandResponse
    extends Array<TimezoneResponse>,
        ICommandResponse {
}
